export default "__VITE_ASSET__DdzRKf47__"